import Vue from 'vue';
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';
import BlockChainUI from 'BlockChain-ui-privatization/PC/components';
import {
  // Table,
  Tooltip,
  // Icon,
  // Pagination,
  // Empty,
  // FormModel,
  // Input,
  // Button,
  // Modal,
  // Tabs,
  // TimePicker,
  // DatePicker,
  // Select,
  // InputNumber,
  // Spin,
  // Radio,
  // ConfigProvider,
  // Carousel,
  // BackTop,
} from 'ant-design-vue';
import {
  Popup,
} from 'vant';
import 'ant-design-vue/dist/antd.min.css';
import 'ant-design-vue/lib/tooltip/style/index.css';
import 'vant/lib/index.css';
// import 'ant-design-vue/lib/table/style/index.css';
// import 'ant-design-vue/lib/icon/style/index.css';
// import 'ant-design-vue/lib/pagination/style/index.css';
// import 'ant-design-vue/lib/empty/style/index.css';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import { colorMap, getCoinShowName } from '@/utils';
import bus from '@/api/bus';
import i18n from '@/locale';
import MixinUdesk from '@/mixin/udesk';
// import VueAwesomeSwiper from 'vue-awesome-swiper';
import App from './App.vue';
import router from './router/index';
import store from './vuex/index';
import axios from './api/http/axios';
import '@/icons/index'; // 加载svg-icon组件
import 'BlockChain-ui-privatization/static/css/common.styl';
import './utils/printProductInfo';
// import 'swiper/swiper-bundle.css';
import '@/assets/css/common.scss';
import '@/assets/font/font.scss';

window.HOSTAPI = 'ex';
Vue.use(vuescroll, {
  ops: {
    rail: {
      opacity: '1',
      background: colorMap['c-5-bd'],
      size: '4px',
      gutterOfSide: '0px',
    },
    bar: {
      background: colorMap['a-2-bg'],
      keepShow: true,
      size: '4px',
      minSize: 0.2,
    },
    scrollPanel: {
      easing: 'easeInQuad',
      speed: 800,
    },
  },
});
Vue.use(BlockChainUI);

Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.$bus = bus;

// Vue.use(Table);
Vue.use(Tooltip);
// Vue.use(Icon);
// Vue.use(Pagination);
// Vue.use(Empty);
// Vue.use(FormModel);
// Vue.use(Input);
// Vue.use(TimePicker);
// Vue.use(Button);
// Vue.use(Modal);
// Vue.use(Tabs);
// Vue.use(Select);
// Vue.use(InputNumber);
// Vue.use(DatePicker);
// Vue.use(Spin);
// Vue.use(Radio);
// Vue.use(ConfigProvider);
// Vue.use(Carousel);
// Vue.use(BackTop);
// Vue.use(VueAwesomeSwiper);
Vue.mixin(MixinUdesk);
Vue.use(Popup);

Vue.filter('getCoinShowName', (name, coinList) => getCoinShowName(name, coinList));

// 只有NODE_ENV为production才启用sentry
// if (process.env.NODE_ENV === 'production') {
//   Sentry.init({
//     Vue,
//     dsn: 'https://test@sentry.mal.io',
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
//       }),
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     environment: process.env.VUE_APP_SENTRY_ENV,
//   });
// }

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
